(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["berlinde-collection-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('berlinde-collections-directory')) {
    class BerlindeCollectionsDirectory extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-bl-collections-connected')) return;

        this.setAttribute('data-bl-collections-connected', 'true');
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-bl-collections-tab]'));
        this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-bl-collections-panel]'));
        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);

        this.tabs.forEach(function (tab) {
          tab.addEventListener('click', this.onClick);
          tab.addEventListener('keydown', this.onKeydown);
        }.bind(this));

        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.selectPanel(this.getAttribute('data-default-panel') || 'women', false);
      }

      disconnectedCallback() {
        this.tabs.forEach(function (tab) {
          tab.removeEventListener('click', this.onClick);
          tab.removeEventListener('keydown', this.onKeydown);
        }.bind(this));

        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.removeAttribute('data-bl-collections-connected');
      }

      onClick(event) {
        this.selectPanel(event.currentTarget.getAttribute('data-bl-collections-tab'), false);
      }

      onKeydown(event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'Home' && event.key !== 'End') return;

        event.preventDefault();
        var currentIndex = this.tabs.indexOf(event.currentTarget);
        var nextIndex = currentIndex;

        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;

        var nextTab = this.tabs[nextIndex];
        this.selectPanel(nextTab.getAttribute('data-bl-collections-tab'), true);
      }

      onBlockSelect(event) {
        var block = event.target.closest('[data-bl-collection-audience]');
        if (!block) return;
        this.selectPanel(block.getAttribute('data-bl-collection-audience'), false);
      }

      selectPanel(panelName, focusTab) {
        var selectedTab = null;

        this.tabs.forEach(function (tab) {
          var selected = tab.getAttribute('data-bl-collections-tab') === panelName;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.setAttribute('tabindex', selected ? '0' : '-1');
          if (selected) selectedTab = tab;
        });

        this.panels.forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-bl-collections-panel') !== panelName;
        });

        if (focusTab && selectedTab) selectedTab.focus();
      }
    }

    customElements.define('berlinde-collections-directory', BerlindeCollectionsDirectory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["berlinde-collection2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('berlinde-collection-ajax')) {
    class BerlindeCollectionAjax extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onPopState = this.onPopState.bind(this);
        this.onFilterToggle = this.onFilterToggle.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.addEventListener('change', this.onChange);
        this.addEventListener('submit', this.onSubmit);
        this.addEventListener('click', this.onClick);
        this.addEventListener('toggle', this.onFilterToggle, true);
        this.addEventListener('keydown', this.onKeydown);
        window.addEventListener('popstate', this.onPopState);
        this.initOfferProgress();
      }

      disconnectedCallback() {
        window.removeEventListener('popstate', this.onPopState);
        this.removeEventListener('toggle', this.onFilterToggle, true);
        this.removeEventListener('keydown', this.onKeydown);
        this.setFilterScrollLock(false);
        if (this.controller) this.controller.abort();
        if (this.offerObserver) this.offerObserver.disconnect();
        if (this.offerUpdateTimer) window.clearTimeout(this.offerUpdateTimer);
      }

      initOfferProgress() {
        if (!this.querySelector('[data-bl-collection-offer]')) return;

        const cartHost = document.querySelector('[data-bl-cart-host]');
        if (cartHost) {
          this.offerObserver = new MutationObserver(() => {
            if (this.offerUpdateTimer) window.clearTimeout(this.offerUpdateTimer);
            this.offerUpdateTimer = window.setTimeout(() => this.updateOfferFromCart(), 80);
          });
          this.offerObserver.observe(cartHost, {
            childList: true,
            subtree: true,
            characterData: true
          });
        }

        this.updateOfferFromCart();
      }

      renderOfferProgress(itemCount) {
        const offer = this.querySelector('[data-bl-collection-offer]');
        if (!offer) return;

        const tiers = [...offer.querySelectorAll('.bl-collection-offer__tier')].map((element) => ({
          element,
          items: Number(element.dataset.items) || 0,
          discount: Number(element.dataset.discount) || 0
        }));
        if (!tiers.length) return;

        tiers.forEach((tier) => tier.element.classList.toggle('is-active', itemCount >= tier.items));
        const maximum = tiers[tiers.length - 1];
        const nextTier = tiers.find((tier) => itemCount < tier.items);
        const progress = Math.min(100, Math.max(0, itemCount / Math.max(1, maximum.items) * 100));
        const track = offer.querySelector('[data-bl-offer-track]');
        if (track) track.style.width = `${progress}%`;

        const message = offer.querySelector('[data-bl-offer-message]');
        if (!message) return;
        const itemWord = itemCount === 1 ? offer.dataset.itemSingular : offer.dataset.itemPlural;
        const emphasized = document.createElement('strong');
        const automaticMessage = document.createElement('span');
        automaticMessage.className = 'bl-collection-offer__auto';
        automaticMessage.textContent = ` — ${offer.dataset.autoDiscountText}`;

        if (nextTier) {
          const needed = nextTier.items - itemCount;
          const neededWord = needed === 1 ? offer.dataset.itemSingular : offer.dataset.itemPlural;
          emphasized.textContent = `${offer.dataset.remainingPrefix} ${needed} ${neededWord} ${offer.dataset.untilLabel} ${nextTier.discount}%`;
        } else {
          emphasized.textContent = offer.dataset.maximumText;
        }

        message.replaceChildren(
          document.createTextNode(`${itemCount} ${itemWord} im Warenkorb · `),
          emphasized,
          automaticMessage
        );
      }

      renderMobileCartBar(cart, itemCount) {
        const bar = this.querySelector('[data-bl-mobile-cart-bar]');
        const offer = this.querySelector('[data-bl-collection-offer]');
        if (!bar || !offer) return;

        bar.hidden = itemCount <= 0;
        const count = bar.querySelector('[data-bl-mobile-cart-count]');
        const total = bar.querySelector('[data-bl-mobile-cart-total]');
        const next = bar.querySelector('[data-bl-mobile-cart-next]');
        if (count) count.textContent = String(itemCount);

        if (total) {
          const currency = cart.currency || window.Shopify?.currency?.active || 'EUR';
          try {
            total.textContent = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
              style: 'currency',
              currency
            }).format((Number(cart.total_price) || 0) / 100);
          } catch (_error) {
            total.textContent = `${((Number(cart.total_price) || 0) / 100).toFixed(2)} ${currency}`;
          }
        }

        if (next) {
          const tiers = [...offer.querySelectorAll('.bl-collection-offer__tier')].map((element) => ({
            items: Number(element.dataset.items) || 0,
            discount: Number(element.dataset.discount) || 0
          }));
          const nextTier = tiers.find((tier) => itemCount < tier.items);
          if (nextTier) {
            const needed = nextTier.items - itemCount;
            const neededWord = needed === 1 ? offer.dataset.itemSingular : offer.dataset.itemPlural;
            next.textContent = `${offer.dataset.remainingPrefix} ${needed} ${neededWord} ${offer.dataset.untilLabel} ${nextTier.discount}% extra`;
          } else {
            next.textContent = offer.dataset.maximumText;
          }
        }
      }

      async updateOfferFromCart() {
        if (this.offerUpdating) {
          this.offerUpdatePending = true;
          return;
        }
        const offer = this.querySelector('[data-bl-collection-offer]');
        if (!offer) return;
        this.offerUpdating = true;

        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const cart = await response.json();
          const protectionVariantId = Number(offer.dataset.protectionVariantId) || 0;
          const itemCount = (cart.items || []).reduce((total, item) => {
            return total + (Number(item.variant_id) === protectionVariantId ? 0 : Number(item.quantity) || 0);
          }, 0);
          this.renderOfferProgress(itemCount);
          this.renderMobileCartBar(cart, itemCount);
        } catch (_error) {
          // Keep the server-rendered Liquid state if the cart endpoint is unavailable.
        } finally {
          this.offerUpdating = false;
          if (this.offerUpdatePending) {
            this.offerUpdatePending = false;
            this.updateOfferFromCart();
          }
        }
      }

      get ajaxEnabled() {
        return this.dataset.blCollectionAjax !== 'false';
      }

      get mobileFilters() {
        return window.matchMedia('(max-width: 749px)').matches;
      }

      onFilterToggle(event) {
        const details = event.target.closest('[data-bl-filter]');
        if (!details || !this.contains(details)) return;

        if (details.open && this.mobileFilters) {
          this.querySelectorAll('[data-bl-filter][open]').forEach((other) => {
            if (other !== details) other.removeAttribute('open');
          });
        }
        this.syncMobileFilterState();
      }

      onKeydown(event) {
        if (event.key !== 'Escape' || !this.mobileFilters) return;
        const details = this.querySelector('[data-bl-filter][open]');
        if (!details) return;
        event.preventDefault();
        this.closeMobileFilter(details);
      }

      closeMobileFilter(details) {
        const summary = details?.querySelector('summary');
        if (details) details.removeAttribute('open');
        this.syncMobileFilterState();
        if (summary) summary.focus({ preventScroll: true });
      }

      syncMobileFilterState() {
        const openDetails = this.mobileFilters
          ? this.querySelector('[data-bl-filter][open]')
          : null;
        this.classList.toggle('is-filter-open', Boolean(openDetails));
        this.querySelectorAll('.bl-filters__pop[role="dialog"]').forEach((dialog) => {
          if (openDetails && openDetails.contains(dialog)) dialog.setAttribute('aria-modal', 'true');
          else dialog.removeAttribute('aria-modal');
        });
        this.setFilterScrollLock(Boolean(openDetails));
      }

      setFilterScrollLock(locked) {
        if (locked && !this.filterScrollElement) {
          const element = document.querySelector('.page-wrapper') || document.documentElement;
          this.filterScrollElement = element;
          this.filterPreviousOverflow = element.style.overflow;
          element.style.overflow = 'hidden';
        } else if (!locked && this.filterScrollElement) {
          this.filterScrollElement.style.overflow = this.filterPreviousOverflow || '';
          this.filterScrollElement = null;
          this.filterPreviousOverflow = '';
        }
      }

      onChange(event) {
        const control = event.target.closest('input[type="checkbox"], select');
        if (!control || !control.closest('[data-bl-filter-form]') || !this.ajaxEnabled) return;
        event.stopPropagation();
        if (this.mobileFilters && control.matches('input[type="checkbox"]')) return;
        this.submitForm(control.closest('[data-bl-filter-form]'), control);
      }

      onSubmit(event) {
        const form = event.target.closest('[data-bl-filter-form]');
        if (!form || !this.ajaxEnabled) return;
        event.preventDefault();
        event.stopPropagation();
        this.submitForm(form, document.activeElement);
      }

      onClick(event) {
        const close = event.target.closest('[data-bl-filter-close]');
        if (close && this.contains(close)) {
          event.preventDefault();
          event.stopPropagation();
          this.closeMobileFilter(close.closest('[data-bl-filter]'));
          return;
        }

        const link = event.target.closest('[data-bl-filter-link]');
        if (!link || !this.contains(link) || !this.ajaxEnabled) return;
        event.preventDefault();
        event.stopPropagation();
        this.refresh(link.href, {
          scrollToResults: link.hasAttribute('data-bl-pagination')
        });
      }

      onPopState() {
        if (this.ajaxEnabled) this.refresh(window.location.href, { updateHistory: false });
      }

      formUrl(form) {
        const url = new URL(form.action, window.location.href);
        const params = new URLSearchParams(new FormData(form));
        [...params.keys()].forEach((key) => {
          if (params.get(key) === '') params.delete(key);
        });
        params.delete('page');
        url.search = params.toString();
        return url.toString();
      }

      submitForm(form, trigger) {
        const focus = trigger && trigger.name
          ? { name: trigger.name, value: String(trigger.value) }
          : null;
        this.refresh(this.formUrl(form), { focus });
      }

      focusMatch(scope, focus) {
        if (!focus) return null;
        return [...scope.querySelectorAll('[name]')].find((element) =>
          element.name === focus.name && String(element.value) === focus.value
        );
      }

      async refresh(url, options = {}) {
        const current = this.querySelector('[data-bl-collection-dynamic]');
        if (!current) {
          window.location.assign(url);
          return;
        }

        const requestUrl = new URL(url, window.location.href);
        requestUrl.searchParams.set('section_id', this.dataset.blCollectionSectionId);
        const historyUrl = new URL(url, window.location.href);
        historyUrl.searchParams.delete('section_id');

        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        current.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(requestUrl.toString(), {
            headers: { Accept: 'text/html' },
            signal: this.controller.signal
          });
          if (!response.ok) throw new Error('Collection update failed');

          const html = await response.text();
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const fresh = parsed.querySelector('[data-bl-collection-dynamic]');
          if (!fresh) throw new Error('Collection response was incomplete');

          const focusTarget = this.focusMatch(fresh, options.focus);
          current.replaceWith(fresh);
          this.syncMobileFilterState();

          if (options.updateHistory !== false) {
            window.history.pushState({}, '', historyUrl.pathname + historyUrl.search + historyUrl.hash);
          }

          if (focusTarget) focusTarget.focus({ preventScroll: true });
          const count = fresh.querySelector('[data-bl-collection-count]');
          const status = fresh.querySelector('[data-bl-filter-status]');
          if (count && status) status.textContent = count.textContent.trim();

          if (options.scrollToResults) {
            fresh.querySelector('[data-bl-collection-results]')?.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        } catch (error) {
          if (error.name === 'AbortError') return;
          window.location.assign(historyUrl.toString());
        }
      }
    }

    customElements.define('berlinde-collection-ajax', BerlindeCollectionAjax);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["berlinde-product"]) return;
  try {
    
  if (!customElements.get('berlinde-product-gallery')) {
    class BerlindeProductGallery extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-gallery-connected')) return;

        this.setAttribute('data-gallery-connected', 'true');
        this.productScope = this.closest('[data-bl-product]');
        this.mainElement = this.querySelector('[data-bl-product-gallery-main]');
        this.thumbsElement = this.querySelector('[data-bl-product-gallery-thumbs]');
        this.previousButton = this.querySelector('[data-bl-gallery-previous]');
        this.nextButton = this.querySelector('[data-bl-gallery-next]');
        this.counter = this.querySelector('[data-bl-gallery-current]');
        this.variants = this.readVariants();
        this.fallbackCleanups = [];
        this.onOptionChange = this.onOptionChange.bind(this);

        if (!this.mainElement) return;

        if (this.productScope) {
          this.productScope.addEventListener('change', this.onOptionChange);
        }

        this.swiperWaitCount = 0;
        this.waitForSwiper();
      }

      disconnectedCallback() {
        window.clearTimeout(this.swiperWaitTimer);

        if (this.productScope) {
          this.productScope.removeEventListener('change', this.onOptionChange);
        }

        this.fallbackCleanups.forEach(function (cleanup) { cleanup(); });
        this.fallbackCleanups = [];

        if (this.mainSwiper && !this.mainSwiper.destroyed) {
          this.mainSwiper.destroy(true, true);
        }

        if (this.thumbsSwiper && !this.thumbsSwiper.destroyed) {
          this.thumbsSwiper.destroy(true, true);
        }

        this.removeAttribute('data-gallery-connected');
      }

      readVariants() {
        if (!this.productScope) return [];

        var variantsNode = this.productScope.querySelector('[data-bl-variants]');
        if (!variantsNode) return [];

        try {
          return JSON.parse(variantsNode.textContent);
        } catch (error) {
          return [];
        }
      }

      waitForSwiper() {
        if (!this.isConnected) return;

        if (typeof window.Swiper === 'function') {
          this.initializeSwiper();
          return;
        }

        this.swiperWaitCount += 1;
        if (this.swiperWaitCount >= 200) {
          this.initializeFallback();
          return;
        }

        this.swiperWaitTimer = window.setTimeout(this.waitForSwiper.bind(this), 50);
      }

      initializeSwiper() {
        if (this.mainSwiper || !this.mainElement) return;

        if (this.thumbsElement) {
          this.thumbsSwiper = new window.Swiper(this.thumbsElement, {
            slidesPerView: 'auto',
            spaceBetween: 9,
            freeMode: true,
            watchSlidesProgress: true,
            slideToClickedSlide: true,
            observer: true,
            observeParents: true
          });
        }

        var initialIndex = this.mediaIndex(this.getAttribute('data-initial-media-id'));
        var options = {
          slidesPerView: 1,
          autoHeight: true,
          spaceBetween: 0,
          speed: 500,
          initialSlide: initialIndex < 0 ? 0 : initialIndex,
          rewind: true,
          watchOverflow: true,
          grabCursor: true,
          keyboard: {
            enabled: true,
            onlyInViewport: true
          },
          observer: true,
          observeParents: true,
          on: {
            init: this.updateCounter.bind(this),
            slideChange: this.updateCounter.bind(this)
          }
        };

        if (this.previousButton && this.nextButton) {
          options.navigation = {
            nextEl: this.nextButton,
            prevEl: this.previousButton
          };
        }

        if (this.thumbsSwiper) {
          options.thumbs = {
            swiper: this.thumbsSwiper,
            autoScrollOffset: 1
          };
        }

        this.mainSwiper = new window.Swiper(this.mainElement, options);
        this.setAttribute('data-bl-gallery-ready', 'true');
        this.syncSelectedVariant(false);
      }

      selectedVariant() {
        if (!this.productScope || !this.variants.length) return null;

        var selectedInputs = Array.prototype.slice.call(
          this.productScope.querySelectorAll('[data-bl-option]:checked')
        );

        selectedInputs.sort(function (first, second) {
          return Number(first.getAttribute('data-bl-option-index')) - Number(second.getAttribute('data-bl-option-index'));
        });

        var selectedOptions = selectedInputs.map(function (input) { return input.value; });

        return this.variants.find(function (variant) {
          return variant.options.length === selectedOptions.length && variant.options.every(function (option, index) {
            return option === selectedOptions[index];
          });
        }) || null;
      }

      onOptionChange(event) {
        if (!event.target.matches('[data-bl-option]')) return;

        window.requestAnimationFrame(function () {
          this.syncSelectedVariant(true);
        }.bind(this));
      }

      syncSelectedVariant(animate) {
        var variant = this.selectedVariant();
        if (!variant || !variant.media_id) return;

        this.goToMedia(variant.media_id, animate);
      }

      mediaIndex(mediaId) {
        var slides = Array.prototype.slice.call(this.mainElement.querySelectorAll('[data-bl-media]'));
        var normalizedId = String(mediaId || '');

        return slides.findIndex(function (slide) {
          return slide.getAttribute('data-bl-media') === normalizedId;
        });
      }

      goToMedia(mediaId, animate) {
        var index = this.mediaIndex(mediaId);
        if (index < 0) return;

        if (this.mainSwiper && !this.mainSwiper.destroyed) {
          this.mainSwiper.slideTo(index, animate === false ? 0 : 500);
          return;
        }

        if (this.hasAttribute('data-bl-gallery-fallback')) {
          this.showFallbackIndex(index);
        }
      }

      updateCounter(swiper) {
        if (!this.counter || !swiper) return;
        this.counter.textContent = String(swiper.realIndex + 1);
      }

      initializeFallback() {
        if (this.hasAttribute('data-bl-gallery-fallback')) return;

        this.setAttribute('data-bl-gallery-fallback', 'true');
        this.fallbackIndex = this.mediaIndex(this.getAttribute('data-initial-media-id'));
        if (this.fallbackIndex < 0) this.fallbackIndex = 0;

        if (this.previousButton) {
          var previousHandler = function () { this.showFallbackIndex(this.fallbackIndex - 1); }.bind(this);
          this.previousButton.addEventListener('click', previousHandler);
          this.fallbackCleanups.push(function () { this.previousButton.removeEventListener('click', previousHandler); }.bind(this));
        }

        if (this.nextButton) {
          var nextHandler = function () { this.showFallbackIndex(this.fallbackIndex + 1); }.bind(this);
          this.nextButton.addEventListener('click', nextHandler);
          this.fallbackCleanups.push(function () { this.nextButton.removeEventListener('click', nextHandler); }.bind(this));
        }

        Array.prototype.slice.call(this.querySelectorAll('[data-bl-thumb-media]')).forEach(function (thumb) {
          var thumbHandler = function () { this.goToMedia(thumb.getAttribute('data-bl-thumb-media'), false); }.bind(this);
          thumb.addEventListener('click', thumbHandler);
          this.fallbackCleanups.push(function () { thumb.removeEventListener('click', thumbHandler); });
        }.bind(this));

        this.showFallbackIndex(this.fallbackIndex);
        this.syncSelectedVariant(false);
      }

      showFallbackIndex(index) {
        var slides = Array.prototype.slice.call(this.mainElement.querySelectorAll('[data-bl-media]'));
        if (!slides.length) return;

        this.fallbackIndex = (index + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          slide.hidden = slideIndex !== this.fallbackIndex;
        }.bind(this));

        Array.prototype.slice.call(this.querySelectorAll('[data-bl-thumb-media]')).forEach(function (thumb, thumbIndex) {
          var active = thumbIndex === this.fallbackIndex;
          thumb.classList.toggle('is-active', active);
          if (active) {
            thumb.setAttribute('aria-current', 'true');
          } else {
            thumb.removeAttribute('aria-current');
          }
        }.bind(this));

        if (this.counter) this.counter.textContent = String(this.fallbackIndex + 1);
      }
    }

    customElements.define('berlinde-product-gallery', BerlindeProductGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["berlinde-top-categories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('berlinde-category-slider')) {
    class BerlindeCategorySlider extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.viewport = this.querySelector('[data-bl-category-viewport]');
        this.previous = this.querySelector('[data-bl-category-previous]');
        this.next = this.querySelector('[data-bl-category-next]');
        this.progress = this.querySelector('[data-bl-category-progress]');
        if (!this.viewport || !this.previous || !this.next || !this.progress) return;
        this.initializeWhenReady();
      }

      disconnectedCallback() {
        if (this.swiperWaitTimer) window.clearInterval(this.swiperWaitTimer);
        if (this.swiper && !this.swiper.destroyed) this.swiper.destroy(true, true);
        if (this.fallbackCleanup) this.fallbackCleanup();
      }

      initializeWhenReady() {
        const startedAt = Date.now();
        const attempt = () => {
          if (!this.isConnected) return;
          if (typeof window.Swiper === 'function') {
            window.clearInterval(this.swiperWaitTimer);
            this.swiperWaitTimer = null;
            this.initializeSwiper();
          } else if (Date.now() - startedAt > 10000) {
            window.clearInterval(this.swiperWaitTimer);
            this.swiperWaitTimer = null;
            this.initializeFallback();
          }
        };

        attempt();
        if (!this.swiper) this.swiperWaitTimer = window.setInterval(attempt, 50);
      }

      initializeSwiper() {
        if (this.swiper || typeof window.Swiper !== 'function') return;

        this.swiper = new window.Swiper(this.viewport, {
          slidesPerView: 'auto',
          slidesPerGroup: 1,
          spaceBetween: 10,
          slidesOffsetBefore: 16,
          slidesOffsetAfter: 16,
          speed: 500,
          watchOverflow: true,
          grabCursor: true,
          observer: true,
          observeParents: true,
          keyboard: {
            enabled: true,
            onlyInViewport: true
          },
          navigation: {
            prevEl: this.previous,
            nextEl: this.next,
            disabledClass: 'swiper-button-disabled'
          },
          pagination: {
            el: this.progress,
            clickable: true,
            bulletClass: 'bl-top-categories__progress-button',
            bulletActiveClass: 'is-active',
            renderBullet(index, className) {
              return `<button type="button" class="${className}" aria-label="Show category slide ${index + 1}"></button>`;
            }
          },
          breakpoints: {
            750: {
              spaceBetween: 16,
              slidesOffsetBefore: 36,
              slidesOffsetAfter: 36
            }
          },
          on: {
            init: () => this.setAttribute('data-bl-swiper-ready', 'true')
          }
        });
      }

      initializeFallback() {
        if (this.fallbackCleanup) return;
        this.setAttribute('data-bl-swiper-fallback', 'true');

        const update = () => {
          const maximum = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
          this.previous.disabled = this.viewport.scrollLeft <= 2;
          this.next.disabled = this.viewport.scrollLeft >= maximum - 2;
        };
        const previous = () => this.viewport.scrollBy({ left: -this.viewport.clientWidth * 0.8, behavior: 'smooth' });
        const next = () => this.viewport.scrollBy({ left: this.viewport.clientWidth * 0.8, behavior: 'smooth' });

        this.previous.addEventListener('click', previous);
        this.next.addEventListener('click', next);
        this.viewport.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();

        this.fallbackCleanup = () => {
          this.previous.removeEventListener('click', previous);
          this.next.removeEventListener('click', next);
          this.viewport.removeEventListener('scroll', update);
          window.removeEventListener('resize', update);
        };
      }
    }

    customElements.define('berlinde-category-slider', BerlindeCategorySlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
